import { t } from 'i18next';
import { Check, X } from 'lucide-react';
import { Trans } from 'react-i18next';

import { Badge } from '@/components/ui/badge';
import { TenantPolicy } from '@activepieces/shared';

type UsagePlanProps = {
  policy: TenantPolicy;
};

export const UsagePlan = ({ policy }: UsagePlanProps) => (
  <div className="flex flex-col gap-1">
    <div className="flex items-center gap-2">
      <span className="text-sm font-medium">{t('Plan')}</span>
      {(policy.tier === 'smart' || policy.tier === 'business') && (
        <Badge variant="secondary">
          {policy.tier === 'business' ? t('Business') : t('Smart')}
        </Badge>
      )}
    </div>
    <div className="flex flex-col gap-1 mt-1 text-xs text-muted-foreground">
      <div className="flex items-center gap-2">
        <Check className="h-3 w-3 shrink-0 text-success" />
        <span>
          {policy.tier === 'smart' ? (
            <Trans
              i18nKey="<strong>{{maxActiveFlows}}</strong> active flows"
              values={{ maxActiveFlows: policy.maxActiveFlows ?? 0 }}
            />
          ) : (
            <Trans i18nKey="<strong>Unlimited</strong> active flows" />
          )}
        </span>
      </div>
      <div className="flex items-center gap-2">
        <Check className="h-3 w-3 shrink-0 text-success" />
        <span>
          <Trans
            i18nKey="<strong>{{tasksQuota}} executions</strong> per month"
            values={{
              tasksQuota: policy.monthlyTasksQuota.toLocaleString(),
            }}
          />
        </span>
      </div>
      {!policy.mcpEnabled && (
        <div className="flex items-center gap-2 opacity-70">
          <X className="h-3 w-3 shrink-0" />
          <span>{t('MCP not included')}</span>
        </div>
      )}
    </div>
  </div>
);
